/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying de ce fichier, via tout médium, est strictement interdite.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

import type { Mention, Registre } from '@/types';

import {
  formatCoordonneesRegistre,
  formatDateNaissance,
  formatLieuIndividu,
  formatMentions,
  formatParent,
  formatSexe,
} from './formatters';

/**
 * Construit le payload de `POST /numerisation-actes/naissance`.
 *
 * ⚠️ Fonction pure, iso-comportement avec l'ancien `useCreateActeNaissance`
 * (avant extraction) : ne pas modifier la forme du payload sans vérifier la
 * non-régression du parcours naissance (payload identique avant/après refactor).
 */
const buildActeNaissancePayload = (
  data: Record<string, any>,
  mentions: Mention[],
  selectedRegistre?: Partial<Registre>,
) => ({
  acte: {
    ...formatCoordonneesRegistre(selectedRegistre, data?.dateActe),
    numeroActe: data?.numeroActe,
    numeroOrdre: data?.ordreActe,
    acteNumeroComplement: data?.complementActe,
    heureDresseActe: data?.heureActe,
    minuteDresseActe: data?.minuteActe,
    identifiantSousTypeActe: data?.sousTypeActe,
    dateNaissance: formatDateNaissance(data),
  },
  enfant: {
    nomFamille: data?.nomFamille,
    prenom: data?.prenom,
    prenomsComplementaires: data?.prenomsComplementaires,
    naissanceHeure: data?.heureNaissance,
    naissanceMinute: data?.minuteNaissance,
    ...formatLieuIndividu(data?.adresseNaissance),
    ...(!_.isNil(formatSexe(data?.sexe)) && { sexe: formatSexe(data?.sexe) }),
  },
  parent1: formatParent(data?.parent1, data?.filiationInconnueParent1),
  parent2: formatParent(data?.parent2, data?.filiationInconnueParent2),
  ...(!_.isEmpty(mentions) && { mentions: formatMentions(mentions) }),
});

export default buildActeNaissancePayload;
